module.exports = __webpack_public_path__ + "static/media/Oluoch_Maurice_Brian_Resume.ee45b3a1.pdf";